import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AdmissionsForm from './components/AdmissionsForm';
import Report from './components/Report';

// Detect if running under /my-college-chances/ subpath
const getBasename = () => {
  const path = window.location.pathname;
  if (path.startsWith('/my-college-chances')) {
    return '/my-college-chances';
  }
  return '';
};

function App() {
  return (
    <Router basename={getBasename()}>
      <div className="App">
        <Routes>
          <Route path="/" element={<AdmissionsForm />} />
          <Route path="/report/:uuid" element={<Report />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
